export default {
    USERINFO: 'userInfo',
    ModifyNickname: 'ModifyNickname',
    LOGINOUT: 'loginOut',
    IMGURL: "imgurl",
    HEADERIMGURL: 'headerimgurl',
    NIKENAME: 'nikename',
    TITLENAME: 'titleName',
    ISSHOWLOGIN: 'isShowLogin',//登录窗显示
    // TOPICLOADED: 'topicLoaded',//loading加载
    CURRENTSTEP:"currentStep",
    PERSONALDETAILS:'personalDetails',//获取个人详细信息详情
    // CASERULESLIST:'caseRulesList',//公司制度列表
    // QUESTIONLIST:'questionList',//课程测验题目列表
    // QUESTIONSORT:'questionSort',//答题卡列表
    MENUS:'menus',//菜单
    AUTHENTICATION:"authentication",//身份认证状态
    RELATIONQUESTION:"relationQuestion",//关联提的列表
	CERTIFICATENUM:'certificateNum',
    NOTECOUNT:'noteCount',//未读通知数
    GETOBJECTLIST: "getobjectlist", //获取大数据列表
    NOTICEKEY:"noticeKey",//通知公告索引权限
};


// WEBPACK FOOTER //
// ./src/constants/types.js